import { withStyles } from "@material-ui/core";
import { getFormattedShipperNameAndAccNumber } from "../ShipperInfo/utils";

const styles = (theme) => ({
  container: {
    width :"100%"
  },
  rowContainer: {
    fontSize: theme.dispatchCardTextFontSize,
  },
  title: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
  },
});
const ShipperMenuItem = ({ data, classes }) => {
    return (
      <div className={classes.container}>
        <div className={classes.rowContainer}>
          <span className={classes.title}>{getFormattedShipperNameAndAccNumber(data.shipperName,data.shipperAccountNumber)}</span>
        </div>
        <div className={classes.rowContainer}>
          <span>{data.shipperAddress ?? ""}</span>
        </div>
      </div>
    );
};

export default withStyles(styles)(ShipperMenuItem);
